import { IExternalPermissions } from 'apps/fleet-planner/types/permissions'

type LoadField = keyof IExternalPermissions

interface IExternalPermissionObject {
  name: LoadField
  isLocked: boolean
}

export const LOAD_FIELDS: Record<LoadField, LoadField> = {
  customers: 'customers',
  loadId: 'loadId',
  rate: 'rate',
  miles: 'miles',
  equipment: 'equipment',
  facility: 'facility',
  appointment: 'appointment',
  details: 'details',
  inOut: 'inOut',
  carrier: 'carrier',
  dropTrailer: 'dropTrailer',
}

export const EXTERNAL_PERMISSIONS: IExternalPermissionObject[] = [
  {
    name: LOAD_FIELDS.customers,
    isLocked: true,
  },
  {
    name: LOAD_FIELDS.loadId,
    isLocked: true,
  },
  {
    name: LOAD_FIELDS.rate,
    isLocked: true,
  },
  {
    name: LOAD_FIELDS.miles,
    isLocked: true,
  },
  {
    name: LOAD_FIELDS.equipment,
    isLocked: true,
  },
  {
    name: LOAD_FIELDS.facility,
    isLocked: true,
  },
  {
    name: LOAD_FIELDS.appointment,
    isLocked: true,
  },
  {
    name: LOAD_FIELDS.details,
    isLocked: true,
  },
  {
    name: LOAD_FIELDS.inOut,
    isLocked: false,
  },
  {
    name: LOAD_FIELDS.carrier,
    isLocked: true,
  },
  {
    name: LOAD_FIELDS.dropTrailer,
    isLocked: false,
  },
]

const isFieldLocked = (isExternalLoad: boolean, permission: boolean) =>
  !!(isExternalLoad && permission)

interface IFieldPermissions {
  customers: boolean
  loadId: boolean
  rate: boolean
  miles: boolean
  equipment: boolean
  facility: boolean
  appointment: boolean
  details: boolean
  inOut: boolean
  dropTrailer: boolean
}

export const externalPermissions = (
  isExternalLoad: boolean | undefined
): IFieldPermissions | {} => {
  if (!isExternalLoad) return {}
  return EXTERNAL_PERMISSIONS.reduce((acc, permission) => {
    return { ...acc, [permission.name]: isFieldLocked(isExternalLoad, permission.isLocked) }
  }, {})
}
